
import icons from './icons'

export default {
  name: 'VsRate',
  props: {
    value: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    stars() {
      return Math.round(this.value / 0.5) * 0.5
    }
  },
  methods: {
    icon(step) {
      const diff = this.stars - step

      if (diff > -0.25) {
        return icons.full
      } else if (diff > -0.75) {
        return icons.half
      } else {
        return icons.empty
      }
    }
  }
}
